import { createContext, useContext, useEffect, useState } from 'react'

import { getAccount } from './api'
import { useAuth } from './auth'
import { useLocation } from 'react-router-dom'

export const UserContext = createContext({})

export const UserContextProvider = ({ children }) => {
	const [loading, setLoading] = useState(true)
	const [user, setUser] = useState({})

	const location = useLocation()
	const { user: authUser } = useAuth()

	useEffect(() => {
		if (
			!authUser ||
			(location.pathname !== '/' && location.pathname !== '/password')
		)
			return

		setLoading(true)
		getAccount()
			.then((res) => {
				setUser(res.data)
			})
			.catch((err) => {
				console.error(err)
			})
			.finally(() => {
				setLoading(false)
			})
	}, [authUser, location.pathname])

	return (
		<UserContext.Provider value={{ loading, user }}>
			{children}
		</UserContext.Provider>
	)
}

export const useUserContext = () => {
	const context = useContext(UserContext)
	if (context === undefined) {
		throw new Error('useUserContext must be used within a UserContextProvider')
	}

	return context
}
